var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBingolottIconSmall = function SvgBingolottIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h26v19H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M17.875 2.75h6.5v6.5h-6.5zm-16.25 0h6.5v6.5h-6.5zm8.125 0h6.5v6.5h-6.5zm-8.125 8.125h6.5v6.5h-6.5zm8.125 0h6.5v6.5h-6.5zm8.125 0h6.5v6.5h-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 17h26v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M1.625 18.625h6.5v6.5h-6.5zm8.125 0h6.5v6.5h-6.5zm8.125 8.125h6.5v6.5h-6.5zm-16.25 0h6.5v6.5h-6.5zm16.25-8.125h6.5v6.5h-6.5zM9.75 26.75h6.5v6.5h-6.5zm-8.125 8.125h6.5v6.5h-6.5zm8.125 0h6.5v6.5h-6.5zm8.125 0h6.5v6.5h-6.5z"
  }))));
};
export default SvgBingolottIconSmall;